<template>
    <div class="c-app">
        <CWrapper>
            <TheHeader />
            <div class="c-body">
                <main class="c-main">
                    <CContainer>
                        <transition name="fade" mode="out-in">
                            <PersonalQRCode :data="secrets" />
                        </transition>
                    </CContainer>
                </main>
            </div>
            <TheFooter />
        </CWrapper>
    </div>
</template>

<script>
import { twoFAMixin } from '@/mixins/2fa';
import PersonalQRCode from '@/components/2FA/PersonalQRCode.vue';
import TheHeader from '@/layouts/TheHeader.vue';
import TheFooter from '@/layouts/TheFooter.vue';

import { getUrlProject } from '@/services/check';

export default {
    name: 'TwoFA',
    components: { PersonalQRCode, TheHeader, TheFooter },
    mixins: [twoFAMixin],
    async created() {
        let project_id = getUrlProject();
        await this.getUser2FAQrcode(project_id);
    },
};
</script>
